import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

import { AttendeeModule } from '~/attendee/attendee.module';
import { ComponentModule } from '~/component/component.module';
import {
  GTM_ID,
  TagManagerService,
} from '~/core/services/tag-manager/tag-manager.service';

import { environment } from '~environments/environment';

import { WidgetLangSelectorComponent } from './components/widget-lang-selector/widget-lang-selector.component';
import { WidgetComponent } from './widget.component';

const routes = [
  {
    path: 'widget',
    component: WidgetComponent,
  },
];

@NgModule({
  declarations: [WidgetComponent, WidgetLangSelectorComponent],
  exports: [WidgetComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
    TranslateModule.forChild(),
    SwiperModule,
    AttendeeModule,
    ComponentModule,
  ],
  providers: [
    {
      provide: GTM_ID,
      useValue: environment.applications.gtm.id,
    },
  ],
})
export class WidgetModule {
  constructor(readonly tagManagerService: TagManagerService) {
    tagManagerService.initialize();
  }
}
